export enum TableActions{
  Delete = 'delete'
}
